module.exports = __webpack_public_path__ + "img/customer-logo-2.c0fe51cd.jpg";